import PropTypes from 'prop-types'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import './index.scss'

import Button from '@/components/Button'

import messages from './messages'

interface ConfirmationOverlayProps {
  message?: ReactNode
  subMessage?: ReactNode
  onConfirm: () => void
  onCancel: () => void
  isWarning: boolean
  onConfirmActionTitle?: ReactNode
  onCancelActionTitle?: ReactNode
  children?: ReactNode
  type?: 'button' | 'submit'
}

const ConfirmationOverlay = ({
  message,
  subMessage,
  onConfirm,
  onCancel,
  isWarning,
  onConfirmActionTitle,
  onCancelActionTitle,
  children,
  type = 'submit'
}: ConfirmationOverlayProps) => (
  <div className="confirmation__overlay">
    <div className="confirmation__box">
      <p className="confirmation__message">{message}</p>
      {!!subMessage && <p className="confirmation__sub_message">{subMessage}</p>}
      {children}
      <div className="confirmation__actionblock">
        <Button type={type} color={'secondary'} onClick={onCancel}>
          {onCancelActionTitle}
        </Button>
        <Button type={type} color={`${isWarning ? 'warning' : 'primary'}`} onClick={onConfirm}>
          {onConfirmActionTitle}
        </Button>
      </div>
    </div>
  </div>
)

ConfirmationOverlay.displayName = 'ConfirmationOverlay'

ConfirmationOverlay.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  children: PropTypes.node,
  isWarning: PropTypes.bool,
  onConfirmActionTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onCancelActionTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

ConfirmationOverlay.defaultProps = {
  message: <FormattedMessage {...messages.confirm} />,
  subMessage: '',
  isWarning: false,
  onConfirmActionTitle: <FormattedMessage {...messages.add} />,
  onCancelActionTitle: <FormattedMessage {...messages.cancel} />
}

export default ConfirmationOverlay
